export default __webpack_public_path__ + "static/media/logo_blue.10e03ad6.jpg";